import { useState } from "react";
import { Link } from "react-router-dom";

const FAQS = [
  {
    q: "How does Hubscroll help users discover new places?",
    a: "Hubscroll makes discovering new places simple by showing curated venue listings, trending locations, and highly rated venues. Users can browse venue profiles, view photos, read reviews, and explore the best places to eat, drink, and socialize in their city."
  },
  {
    q: "Can businesses list their venue on Hubscroll?",
    a: (
      <span>
        Yes. Hospitality businesses such as cafés, restaurants, bars, and lounges can create a venue listing on Hubscroll. Once listed, the venue becomes discoverable inside the Hubscroll mobile app, helping attract new customers. Businesses can create their listing here:{" "}
        <Link to="/sign-up" className="lp-text-blue" style={{ textDecoration: "underline" }}>
          hubscroll.app/sign-up
        </Link>
      </span>
    )
  },
  {
    q: "How long does it take to list a venue?",
    a: "Creating a venue listing on Hubscroll takes only a few minutes. Business owners simply create an account, add their venue information, upload photos, and publish their listing. Once completed, the venue becomes visible to users exploring the platform."
  },
  {
    q: "Why should hospitality businesses join Hubscroll?",
    a: "Hubscroll helps hospitality businesses increase visibility and attract new customers. By listing a venue on the platform, businesses appear inside a modern discovery app used by people actively searching for places to visit in Dubai and across the UAE."
  },
  {
    q: "What makes Hubscroll different from other discovery platforms?",
    a: "Hubscroll focuses specifically on the UAE hospitality market and provides a modern mobile-first experience for discovering venues. The platform combines beautiful venue profiles, real user reviews, curated discovery, and a seamless mobile experience to make finding new places easier than ever."
  },
  {
    q: "How can I stay updated with new venues?",
    a: "Users can stay updated by regularly exploring the Hubscroll mobile app, where new venues, trending locations, and popular places are highlighted. Downloading the Hubscroll app is the easiest way to stay connected with the latest discoveries across Dubai and the UAE."
  }
];

export function LandingFAQSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="lp-py-16 lp-px-6 lp-relative lp-z-10">
      <div className="lp-max-3xl lp-mx-auto">
        
        {/* Section Divider with Header */}
        <div className="lp-section-divider">
          <span
            className="lp-text-dark lp-text-xl lp-uppercase lp-tracking-wide lp-px-4"
            style={{ fontFamily: "'Fraunces', serif", fontWeight: 500, letterSpacing: "0.05em" }}
          >
            Hubscroll FAQ
          </span>
        </div>

        {/* FAQ List */}
        <div className="lp-flex lp-flex-col">
          {FAQS.map((faq, index) => {
            const isOpen = activeIndex === index;
            return (
              <div key={index} className="lp-faq-item">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="lp-faq-question"
                  style={{ fontFamily: "'Fraunces', serif" }}
                >
                  <span>{faq.q}</span>
                  <span 
                    style={{ 
                      transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", 
                      transition: "transform 0.3s ease",
                      fontSize: "1.2rem",
                      color: isOpen ? "#4A9EFF" : "var(--lp-color-text-dark)"
                    }}
                  >
                    ▼
                  </span>
                </button>
                <div 
                  className={`lp-faq-answer ${isOpen ? "lp-open" : ""}`}
                  style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
                >
                  <p>{faq.a}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
